function EditIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="#4079F5" {...props}>
      <path d="M2 11.5V14h2.5l7.373-7.374-2.5-2.5L2 11.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z" />
    </svg>
  )
}

export default EditIcon
